import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { LocationsGroupsService } from 'app/main/locations-groups/services/locations-groups-resolver.service';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return LocationGroupLegacyComponent; }),
    multi: true
};
var LocationGroupLegacyComponent = /** @class */ (function () {
    function LocationGroupLegacyComponent(fuseTranslationLoaderService, locationsGroupsApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.locationsGroupsApi = locationsGroupsApi;
        this.locationsGroups = new Array();
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    LocationGroupLegacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.inputValue.valueChanges
            .pipe(filter(function (searchTerm) {
            return !!searchTerm;
        }), debounceTime(500), switchMap(function (searchTerm) {
            _this.loading = true;
            _this.locationsGroups = [];
            return _this.locationsGroupsApi.getLocationsGroups({
                where: {
                    name_contains: searchTerm,
                    archived: false
                },
                options: {
                    orderBy: 'name_asc',
                    offset: 0,
                    limit: 10
                }
            });
        }))
            .subscribe(function (result) {
            _this.loading = false;
            _this.locationsGroups = result.items;
        });
    };
    LocationGroupLegacyComponent.prototype.writeValue = function (locationGroupId) {
        var _this = this;
        if (locationGroupId) {
            this.locationsGroupsApi.getLocationGroup(locationGroupId)
                .then(function (locationGroup) {
                _this.selectedLocationGroup = locationGroup;
                _this.hasSelectedLocationGroup = true;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectLocationGroup();
        }
    };
    LocationGroupLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    LocationGroupLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    LocationGroupLegacyComponent.prototype.setSelectedLocationGroup = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.inputValue.setErrors(null);
            this.onChange(this.inputValue.value);
            this.selectedLocationGroup = this.locationsGroups
                .find(function (locationGroup) { return locationGroup.id === _this.inputValue.value; });
            this.hasSelectedLocationGroup = true;
        }
    };
    LocationGroupLegacyComponent.prototype.deselectLocationGroup = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.inputValue.setErrors(null);
        this.selectedLocationGroup = null;
        this.hasSelectedLocationGroup = false;
    };
    return LocationGroupLegacyComponent;
}());
export { LocationGroupLegacyComponent };
